module.exports = __webpack_public_path__ + "img/slide3-contenten.ecf41c26.png";